export interface RegionCatalogItem {
  slug: string;
  clv: string;
  name: string;
  gridPath: string;
  deprecated?: boolean;
}

export const REGION_CATALOG: RegionCatalogItem[] = [
  { slug: "norte", clv: "1NO", name: "Norte", gridPath: "/maps/zones/norte_grid_data.json" },
  { slug: "altos_norte", clv: "2AN", name: "Altos Norte", gridPath: "/maps/zones/altos_norte_grid_data.json" },
  { slug: "altos_sur", clv: "3AS", name: "Altos Sur", gridPath: "/maps/zones/altos_sur_grid_data.json" },
  { slug: "cienaga", clv: "4CI", name: "Ciénega", gridPath: "/maps/zones/cienaga_grid_data.json" },
  { slug: "sureste", clv: "5SE", name: "Sureste", gridPath: "/maps/zones/sureste_grid_data.json" },
  { slug: "sur", clv: "6SU", name: "Sur", gridPath: "/maps/zones/sur_grid_data.json" },
  { slug: "sierra_amula", clv: "7SA", name: "Sierra de Amula", gridPath: "/maps/zones/sierra_amula_grid_data.json" },
  { slug: "costa_sur", clv: "8CS", name: "Costa Sur", gridPath: "/maps/zones/costa_sur_grid_data.json" },
  { slug: "sierra_occidental", clv: "9SO", name: "Sierra Occidental", gridPath: "/maps/zones/sierra_occidental_grid_data.json" },
  { slug: "costa_sierra", clv: "9CS", name: "Costa Sierra Occidental", gridPath: "/maps/zones/costa_sierra_grid_data.json", deprecated: true },
  { slug: "lagunas", clv: "10LA", name: "Lagunas", gridPath: "/maps/zones/lagunas_grid_data.json" },
  { slug: "valles", clv: "11VA", name: "Valles", gridPath: "/maps/zones/valles_grid_data.json" },
  { slug: "centro", clv: "12CE", name: "Centro", gridPath: "/maps/zones/centro_grid_data.json" },
  { slug: "costa_norte", clv: "13CN", name: "Costa Norte", gridPath: "/maps/zones/costa_norte_grid_data.json" },
  { slug: "zona_costera", clv: "14ZC", name: "Zona Costera", gridPath: "/maps/zones/zona_costera_grid_data.json" },
  { slug: "jalisco", clv: "JAL", name: "Estado de Jalisco", gridPath: "/maps/states/jalisco_grid_data.json" },
  { slug: "amg", clv: "AMG", name: "Área Metropolitana de Guadalajara - AMG", gridPath: "/maps/zones/amg_grid_data.json" },
  { slug: "tepic", clv: "TEP", name: "Región prueba Tepic", gridPath: "/maps/zones/tepic_grid_data.json" },
];

